import React from 'react';
import { AttributeValueFormModalView } from './AttributeValueFormModalView';
import {
    useAttributeValueForm,
    type AttributeValueFormValues,
} from './useAttributeValueForm';

type AttributeValueFormModalProps = {
    error: string | null;
    initialValues: AttributeValueFormValues | null;
    isOpen: boolean;
    isSubmitting: boolean;
    mode: 'create' | 'edit';
    onClose: () => void;
    onSubmit: (input: AttributeValueFormValues) => void;
};

/**
 * Container for the Add / Edit value modal: instantiates the form-state hook
 * and hands its output (plus the modal-chrome props) to the render-only View.
 */
export const AttributeValueFormModal: React.FC<
    AttributeValueFormModalProps
> = ({
    error,
    initialValues,
    isOpen,
    isSubmitting,
    mode,
    onClose,
    onSubmit,
}) => {
    const form = useAttributeValueForm({
        initialValues: initialValues ?? undefined,
        isOpen,
        mode,
        onSubmit,
    });

    return (
        <AttributeValueFormModalView
            error={error}
            form={form}
            isOpen={isOpen}
            isSubmitting={isSubmitting}
            mode={mode}
            onClose={onClose}
        />
    );
};
